import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Image, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { IoArrowBackOutline, IoCallOutline, IoChatbubbleEllipsesOutline, IoCloudDownloadOutline, IoCreateOutline, IoMailOutline, IoTrashOutline } from 'react-icons/io5';
import imgPlaceholder from '../../../../assets/images/placeholder/customer-image-placeholder.png';
import OutletHead from '../../../../components/common/outlet-head';
import { db } from '../../../../firebase';
import { deleteDoc, doc } from 'firebase/firestore';
import './index.css';

function AssociateDetails() {

  const location = useLocation();
  let navigate = useNavigate();

  const [data, setData] = useState(null);
  const [item, setItem] = useState(null);
  const [showDelete, setShowDelete] = useState(false);

  const handleClose = () => setShowDelete(false);

  useEffect(() => {
    let { state } = location;
    setData(state.data);
    setItem(state.items);
  }, [location]);

  async function handleDeleteItem() {
    await deleteDoc(doc(db, "Parties", item.id));
    navigate('/admin/parties');
  }

  return (
    <section className='section'>
      <div className='row'>
        <div className='col-12'>
          <OutletHead
            left={
              <div className='d-flex align-items-center'>
                <Button
                  variant='light'
                  size='sm'
                  className='p-2 me-3 rounded-circle'
                  onClick={() => navigate(-1)}
                >
                  <IoArrowBackOutline size={24} />
                </Button>
                <h5 className='mb-0 fw-600'>{item && item.name}</h5>
              </div>
            }
            right={
              <div className='d-flex align-items-center justify-content-end'>
                <Button
                  variant="outline-primary"
                  type="button"
                  className='py-2 px-4'
                >
                  <IoCloudDownloadOutline size={20} />
                  <span className='ps-2'>Downlaod Report</span>
                </Button>
              </div>
            } />
          <div className='inner-wrapper p-3 border-top'>
            {item && item ?
              <div className='row'>
                <div className='col-12'>
                  <div className='bg-light rounded p-3 d-flex align-items-center justify-content-between'>
                    <div className='d-flex align-items-start'>
                      <div className='profile-image'>
                        <Image
                          src={item.photo ? item.photo : imgPlaceholder}
                          alt='party-photo'
                          fluid
                          thumbnail
                          rounded />
                      </div>
                      <div className='info-tag ps-3'>
                        <h5 className='mb-0'>{item.name ? item.name : "-"}</h5>
                        <p><span className='text-muted'>Father/Husband - </span> {item.fatherHusband ? item.fatherHusband : "-"}</p>
                        <div className='d-flex align-items-center justify-content-start'>
                          <div className='me-3'>
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  Make Call
                                </Tooltip>
                              }
                            >
                              <Button
                                variant='light'
                                className='px-2 py-2'
                              >
                                <IoCallOutline size={20} />
                              </Button>
                            </OverlayTrigger>
                          </div>
                          <div className='me-3'>
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  Send Email
                                </Tooltip>
                              }
                            >
                              <Button
                                variant='light'
                                className='px-2 py-2'
                              >
                                <IoMailOutline size={20} />
                              </Button>
                            </OverlayTrigger>
                          </div>
                          <div className='me-3'>
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip id="tooltip-bottom">
                                  Send Message
                                </Tooltip>
                              }
                            >
                              <Button
                                variant='light'
                                className='px-2 py-2'
                              >
                                <IoChatbubbleEllipsesOutline size={20} />
                              </Button>
                            </OverlayTrigger>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='d-flex align-items-start'>
                      <div className='text-center bg-white p-3 rounded custom-shadow'>
                        <h3>0</h3>
                        <div>Active Leads</div>
                      </div>
                      <div className='text-center bg-white p-3 rounded custom-shadow mx-3'>
                        <h3>0</h3>
                        <div>Closed Leads</div>
                      </div>
                      <div className='text-center bg-white p-3 rounded custom-shadow'>
                        <h3>0</h3>
                        <div>Total Leads</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-md-4 col-12 ps-4 mt-3'>
                  <div className='row bg-light rounded pb-3 px-2'>
                    <h6 className='info-head text-muted py-3 border-bottom'>Basic Details</h6>
                    <div className='col-lg-6 col-md-6 col-12'>
                      <div className='info-tag'>
                        <span>Date of Birth</span>
                        <p>{item.dob ? item.dob : "-"}</p>
                      </div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-12 text-end'>
                      <div className='info-tag'>
                        <span>Gender</span>
                        <p className='text-capitalize'>{item.gender ? item.gender : "-"}</p>
                      </div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-12'>
                      <div className='info-tag'>
                        <span>Aadhar Number</span>
                        <p>{item.aadharNumber ? item.aadharNumber : "-"}</p>
                      </div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-12 text-end'>
                      <div className='info-tag'>
                        <span>Pan Number</span>
                        <p>{item.panNumber ? item.panNumber : "-"}</p>
                      </div>
                    </div>
                    <h6 className='info-h text-muted py-3 border-bottom border-top'>Contact Details</h6>
                    <div className='col-12'>
                      <div className='info-tag'>
                        <span>Address</span>
                        <p className='mb-0'>{item.address ? item.address + ", " : ""}{item.city ? item.city + ", " : ""}{item.pincode ? item.pincode + ", " : ""}</p>
                        <p>{item.state ? item.state + ", " : ""}{item.country ? item.country : ""}</p>
                      </div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-12'>
                      <div className='info-tag'>
                        <span>Phone Number</span>
                        <p>+91 {item.phoneNumber ? item.phoneNumber : "-"}</p>
                      </div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-12'>
                      <div className='info-tag text-end'>
                        <span>Alternate Number</span>
                        <p>+91 {item.alternatePhoneNumber ? item.alternatePhoneNumber : "-"}</p>
                      </div>
                    </div>
                    <div className='col-12'>
                      <div className='info-tag'>
                        <span>Email Address</span>
                        <p className='mb-0'>{item.email ? item.email : "-"}</p>
                      </div>
                    </div>
                    <div className='mt-5'>
                      <Link
                        to="../edit"
                        state={item}
                      >
                        <Button
                          variant="outline-primary"
                          type="button"
                          className='py-2 px-3 w-100 me-3'
                        >
                          <IoCreateOutline size={20} />
                          <span className='ps-2'>Edit</span>
                        </Button>
                      </Link>
                      <div className='mt-3'>
                        <Button
                          variant="danger"
                          type="button"
                          className='py-2 px-3 w-100 me-3'
                        >
                          <IoTrashOutline size={20} />
                          <span className='ps-2'>Delete</span>
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-md-8 col-12 p-3'>
                  <div className='h-100 bg-light rounded text-center'>
                    <h5 className='p-3 mb-0 pb-1'>Activities (Top Tabs)</h5>
                    <p className='text-muted'>
                      Example - Active Leads, Closed Leads & All Leads
                    </p>
                  </div>
                </div>
              </div>
              :
              null}
          </div>
        </div>
      </div>

      <Modal
        show={showDelete}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className='mb-0 text-center'>Are you sure, you want to delete?</h5>
        </Modal.Body>
        <Modal.Footer className='justify-content-center'>
          <Button
            variant="outline-dark"
            onClick={handleClose}
            className='px-5 py-2'
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            className='px-5 py-2'
            onClick={handleDeleteItem}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
}

export default AssociateDetails;
